import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router';
import { CertificateViewer } from './components/certificate-viewer';
import { NotFound } from '@/components/shared/not-found';
import { useCertificatesIndex } from '@/data/certificates';

const FullPageContainer = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
    }}
  >
    {children}
  </Box>
);

export const VerificationPage = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const { certificate, isFetching, isInvalid } = useCertificatesIndex({
    uuid: uuid ?? '',
  });

  if (isFetching) {
    return (
      <FullPageContainer>
        <CircularProgress />
      </FullPageContainer>
    );
  }

  if (isInvalid || !certificate) {
    return (
      <FullPageContainer>
        <Box p={4}>
          <NotFound
            buttonText=""
            centered
            description="Verifique se o endereço foi digitado corretamente ou peça um certificado atualizado para quem compartilhou com você."
            title="Não encontramos um certificado neste link."
          />
        </Box>
      </FullPageContainer>
    );
  }

  return <CertificateViewer certificate={certificate} />;
};
